module.exports = __webpack_public_path__ + "static/media/anim-1-expand.6d3022c9.png";